import { createContext, useState } from 'react';
import { ChannelStatus } from './Channels.interface';
import { Channel } from '../../../features/api/apiSlice';
import { useSocketApi } from '../../../hooks/useSocketApi';

interface ChannelStatusContextProps {
  channelStatuses: ChannelStatus;
  setChannelStatuses: React.Dispatch<React.SetStateAction<ChannelStatus>>;
  broadcastId?: number | null;
}

const ChannelStatusContext = createContext<ChannelStatusContextProps>({
  channelStatuses: {},
  setChannelStatuses: () => { },
  broadcastId: null,
});

export const getInitialStatuses = (channels: Channel[] = []): ChannelStatus => {
  return channels.reduce((acc: ChannelStatus, channel) => {
    acc[channel.id] = channel.status;
    return acc;
  }, {});
};

const ChannelStatusProvider = ({ children, broadcastId}: { children: React.ReactNode; broadcastId?: number }) => {
  const [channelStatuses, setChannelStatuses] = useState<ChannelStatus>({});

  useSocketApi({
    broadcastId,
    onChannelStatusUpdated: (payload) => {
      const { restream_template, broadcast_id } = payload;

      if (broadcastId && broadcast_id !== broadcastId) {
        return;
      }

      if (restream_template && typeof restream_template.id === 'number' && restream_template.status) {
        setChannelStatuses(prevStatuses => ({
          ...prevStatuses,
          [restream_template.id]: restream_template.status
        }));
      }
    }
  });

  return (
    <ChannelStatusContext.Provider value={{
      channelStatuses,
      setChannelStatuses,
      broadcastId
    }}>
      {children}
    </ChannelStatusContext.Provider>
  );
};

export { ChannelStatusProvider, ChannelStatusContext };